import { Text, View } from '@react-pdf/renderer';
import React from 'react';
import { styles } from './styles';

export const CustomerDetails = ({customer}) => {
	const {firstName, lastName, email, company} = customer;
	return (
		<View style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-end'}}>
			<Text style={styles.text.white}>{company ?? ''}</Text>
			<Text style={styles.text.white}>{firstName ?? ''} {lastName ?? ''}</Text>
			<Text style={styles.text.white}>{email ?? ''}</Text>
		</View>
	)
};
